import { IFormField } from 'models/app';
import React, { useEffect, useState } from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { InputTypes } from 'enums/inputTypes';
import { IClient } from 'models/clients';
import { IService } from 'models/services';
import { ISubscriptionInput } from 'models/subscription';
import { IPlan } from 'models/plan';



interface Props {
  open: boolean;
  loading: boolean;
  clients:IClient[];
  services:IService[];
  plans:IPlan[];
  inputObj:ISubscriptionInput;
  title:string;
  disabled?:boolean;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddSubscriptionModal: React.FC<Props> = ({ open,clients,services, inputObj,plans, loading, title,disabled, onClose, onSubmit, onChanges }) => {



  const [selectedPlan, setSelectedPlan] = useState<string>("");
  let clientsOptions = clients.map((client) => {return { value: client.clientId.toString(), label: client.clientName }});
  let servicesOptions = services.map((service) => {return { value: service.serviceId.toString(), label: service.serviceName }});
  let plansOptions = services.find(service => service.serviceId.toString() === inputObj?.serviceId?.toString())?.plans?.map((plan) => {return { value: plan.toString(), label: plans.find(item => item.planId === plan )?.planName || plan.toString()  }}) || [];


  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedPlan(event.target.value as string);
    onChanges('planId',event.target.value)
  };


  useEffect(()=>{
    setSelectedPlan('')
    onChanges('planId','')
  },[inputObj.serviceId])

  let basicFields: IFormField[] = [
    
    {
      name: 'clientId',
      label: 'Client',
      placeholder: 'Select Client',
      type: InputTypes.SELECT,
      options:clientsOptions,
      internalLabel: true,

      required: true
    }, 
    {
      name: 'serviceId',
      label: 'Service',
      placeholder: 'Select Service',
      type: InputTypes.SELECT,
      options:servicesOptions,
      internalLabel: true,
      required: true
    }, 
    
  
    
  ];

  let basicFields2: IFormField[] = [
    
    {
      name: 'startDate',
      label: 'Start Date',
      placeholder: 'Select Start Date',
      type: InputTypes.CALENDER,
      internalLabel: true,
      required: true
    }, 
    
  ];


return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
    <   FormControl fullWidth>
          <InputLabel id="plan-select-label">Select Plan</InputLabel>
          <Select
            disabled={!inputObj.serviceId}
            labelId="service-select-label"
            value={selectedPlan}
            onChange={handleChange}
          >
          {plansOptions.map((plan) => (
          <MenuItem key={plan.value} value={plan.value}>
            {plan.label}
          </MenuItem>
          ))}
        </Select>
      </FormControl>
        <Form fields={basicFields2} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {'Cancel'}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading || disabled}
            size='large' onClick={onSubmit}>
            {'Add'}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddSubscriptionModal;
